import React, { useEffect, useState } from 'react'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// Removed Button, Card, Col, Row, Select imports
import { API } from 'aws-amplify'
import moment from 'moment'
// Added CB component imports
import { CBButton, CBCard, CBSelect } from '../../core/components/cbd';

import JSONTree from 'react-json-tree'
import BoomerCalendar from './BoomerCalendar'
import ScanSyncItem from './ScanSyncItem'

function SyncItem({ bridge, theme, accounts, pushSubscriptionStatus }) {
	const [infoExpanded, setInfoExpanded] = useState(false);
	const [loading, setLoading] = useState(false);
	const [ver, setVer] = useState({});
	const [currentMonth, setCurrentMonth] = useState(0)
	const findSrcAccount = accounts.filter(acc => acc.calendarAccountId == bridge.sourceCalendarAccountId)
	const findDestAccount = accounts.filter(acc => acc.calendarAccountId == bridge.destCalendarAccountId)
	
	const sourceAccount = findSrcAccount.length > 0 ? findSrcAccount[0] : {displayName: "Src Account Missing", email: "Something is wrong"}
	const destAccount = findDestAccount.length > 0 ? findDestAccount[0] : {displayName: "Dest Account Missing", email: "Something is wrong"}
    console.log("Source account")
	console.log(sourceAccount)
	console.log(destAccount)
	useEffect(() => {

		if (infoExpanded) {
			loadDetails()
		}
	}, [currentMonth])

	async function bumpSync() {
		setLoading(true);
		try {
			const responseDetails = await await API.post('scan', '/scan', {
				body: {
					bridgeId: bridge.id,
					action: "bumpSync"
				}
			});
			// console.log(responseDetails);
		} finally {
			setLoading(false);
		}
	}

	async function desync() {
		setLoading(true);
		try {
			const responseDetails = await await API.post('scan', '/scan', {
				body: {
					bridgeId: bridge.id,
					action: "desyncBridge"
				}
			});
			// console.log(responseDetails);
		} finally {
			setLoading(false);
		}
	}

	async function loadDetails() {
		try {
			const responseDetails = await await API.get('scan', '/scan', {
				queryStringParameters: {
					bridgeId: bridge.id,
					month: currentMonth,
					action: "getSyncDetails"
				}
			});
			setVer(responseDetails.results)
			setInfoExpanded(true)
		} catch (ex) {
			//console.log(ex)
			alert('Sync Too Dang Big')
		} finally {
			setLoading(false);
		}
	}

	async function toggleExpand() {
		setLoading(true);
		if (infoExpanded) {
			setVer({});
			setInfoExpanded(false);
			setLoading(false);
		} else {
			loadDetails()
		}
	}


	if (infoExpanded === false) {
		return (
			// Replaced Card with CBCard
			<div className="mb-4 p-2 border border-gray-700 w-full lg:w-2/3"> {/* Added margin */}
				<ScanSyncItem item={bridge}
					sourceAccountName={`${sourceAccount.displayName}-${sourceAccount.email}`}
					destAccountName={`${destAccount.displayName}-${destAccount.email}`}
				/>
				{/* Replaced Row/Col with Flexbox */}
				<div className="flex space-x-2 mt-4 mb-4"> {/* Added spacing */}
						<CBButton type="ternary" onClick={toggleExpand}>Expand</CBButton>
						<CBButton type="ternary"onClick={bumpSync}>Bump the sync</CBButton> {/* Removed type="secondary" */}
						<CBButton type="ternary" onClick={desync}>Desync</CBButton> {/* Removed type="secondary" */}
				</div>
				<div className="pb-4"> {/* Replaced style with Tailwind */}
					{loading && <FontAwesomeIcon icon={faSpinner} spin />}
				</div>

				{typeof pushSubscriptionStatus !== 'undefined' && <div className="text-sm mb-1">Push Subscription Status: {pushSubscriptionStatus ? 'Active' : 'Not Active'}</div>} {/* Added styling */}
				{<h1 className="text-sm mb-1">Sync Status: {bridge.status}</h1>} {/* Added styling */}
				{<div className="text-sm mb-1">Sync Active: {bridge.active ? 'Active' : "De-Activated"}</div>} {/* Added styling */}
				{<div className="text-sm mb-1">Sync Created : {moment(bridge.modified).format('LLLL')}</div>} {/* Added styling */}
				{<div className="text-sm mb-1">Last sync: {moment(Math.abs(bridge.lastSyncTime)).format('LLLL')}</div>} {/* Added styling */}
				{<div className="text-sm mb-1">Resynced: {bridge.resynced == 0 ? "NOT YET" :moment(Math.abs(bridge.resynced)).format('LLLL')}</div>} {/* Added styling */}
				{/* {<div>Push Active: {sourceSub != null ? 'True' : 'False'}</div>} */}

				{bridge.errorState && bridge.errorState != '' && (
					<div className="text-red-600 text-sm mb-1">Error: {bridge.errorState}</div> // Added styling
				)}
				<div className="text-sm font-semibold mt-2">Raw Bridge:</div> {/* Added styling */}
				<JSONTree
					data={{ items: bridge }}
					hideRoot={true}
					theme={theme}
				/>
			</div>
		);
	}
	const now = moment()
	// Prepare options for month Select
	const monthOptions = Array.from({ length: 15 }, (_, i) => i - 2).map(offset => ({
		label: now.clone().add(offset, 'month').format('MMMM YYYY'),
		value: offset
	}));

	return (
		// Replaced Card with CBCard
		<div className="mb-4 p-2 border border-gray-700"> {/* Added margin */}
			<ScanSyncItem item={ver.bridge} sourceAccountName={`${ver.srcAccount.displayName}-${ver.srcAccount.email}`}
				destAccountName={`${ver.destAccount.displayName}-${ver.destAccount.email}`} />
			{/* Replaced Row/Col with Flexbox */}
			<div className="flex space-x-2 mt-4 mb-4"> {/* Added spacing */}
				<CBButton type="ternary" onClick={toggleExpand}>Collapse</CBButton>
				<CBButton type="ternary" onClick={bumpSync}>Bump the sync</CBButton> {/* Removed type="secondary" */}
				<CBButton type="ternary" onClick={desync}>Desync</CBButton> {/* Removed type="secondary" */}
			</div>

			<div className="pb-4"> {/* Added padding */}
				{loading && <FontAwesomeIcon icon={faSpinner} spin />}
			</div>

			{<div className="text-sm mb-1">Sync Status: {ver.bridge.status}</div>} {/* Added styling */}
			{<div className="text-sm mb-1">Sync Active: {ver.bridge.active ? 'Active' : "De-Activated"}</div>} {/* Added styling */}
			{<div className="text-sm mb-1">Sync Created : {moment(bridge.modified).format('LLLL')}</div>} {/* Added styling */}
			{<div className="text-sm mb-1">Last sync: {moment(bridge.lastSyncTime).format('LLLL')}</div>} {/* Added styling */}
			{<div className="text-sm mb-1">Push Active: {ver.sourceSub != null ? 'True' : 'False'}</div>} {/* Added styling */}

			{ver.bridge && ver.bridge.errorState && ver.bridge.errorState != '' && (
				<div className="text-red-600 text-sm mb-1">Error: {ver.bridge.errorState}</div> // Added styling
			)}
			<div className="text-sm font-semibold mt-2">Raw Bridge:</div> {/* Added styling */}
			<JSONTree
				data={{ items: ver.bridge }}
				hideRoot={true}
				theme={theme}
			/>

			{/* Replaced Row/Col with div */}
			<div className="my-4"> {/* Added margin */}
				<label className="block text-sm font-medium text-gray-700 mb-1">Month:</label> {/* Added label */}
				{/* Replaced Select with CBSelect */}
				<CBSelect
					labels={monthOptions.map(opt => opt.label)}
					values={monthOptions.map(opt => opt.value)}
					selected={currentMonth} // Use currentMonth state
					onChange={e => {
						setCurrentMonth(parseInt(e, 10)) // Ensure value is number
					}}
					style={{ width: 200 }} // Keep width for now
				/>
			</div>
		<BoomerCalendar month={currentMonth} sourceItems={ver.sourceItems} destItems={ver.destItems} bridge={ver.bridge}></BoomerCalendar>
		<div className="text-sm font-semibold mt-4">Source Items (current month)</div> {/* Added styling */}
		<JSONTree
			data={{ items: ver.sourceItems }}
			hideRoot={true}
			theme={theme}
		/>
Dest Items (current month)
		<JSONTree
			data={{ items: ver.destItems }}
			hideRoot={true}
			theme={theme}
		/>
Mappings
		<JSONTree
			data={{ items: ver.mappings }}
			hideRoot={true}
			theme={theme}
		/>
		<div className="text-sm font-semibold mt-4">Source Account: {ver.srcAccount.displayName}-{ver.srcAccount.email}</div> {/* Added styling */}
		<JSONTree
			data={{ item: ver.srcAccount }}
			hideRoot={true}
			theme={theme}
		/>
		<div className="text-sm font-semibold mt-4">Source Calendars</div> {/* Added styling */}
		<JSONTree
			data={{ items: ver.srcCals }}
			hideRoot={true}
			theme={theme}
		/>
		<div className="text-sm font-semibold mt-4">Dest Account: {ver.destAccount.displayName}-{ver.destAccount.email}</div> {/* Added styling */}
		<JSONTree
			data={{ item: ver.destAccount }}
			hideRoot={true}
			theme={theme}
		/>
		<div className="text-sm font-semibold mt-4">Dest Calendars</div> {/* Added styling */}
		<JSONTree
			data={{ items: ver.destCals }}
			hideRoot={true}
			theme={theme}
		/>
	</div> // Corrected closing tag
	);
}

export default SyncItem;
